import script from "./PlanSelectorProduct2.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanSelectorProduct2.vue?vue&type=script&setup=true&lang=ts"

import "./PlanSelectorProduct2.vue?vue&type=style&index=0&id=3338fca3&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3338fca3"]])

export default __exports__